import styled from 'styled-components'

import { breakpoints } from '@awazevr/design-system.utils.react'

const MOBILE_GUTTER = '16px'

export const PropertiesNearbyContainer = styled.section`
  /* minmax(0, 1fr) keeps the track (and carousel) from growing to its content
     width and overflowing the column. */
  display: grid;
  grid-template-columns: minmax(0, 1fr);
  overflow: hidden;
  margin-top: 1.5rem;
  margin-bottom: 40px;

  /* Mobile: break out to the viewport edges so the carousel bleeds off-page. */
  width: 100vw;
  margin-left: 50%;
  transform: translateX(-50%);

  @media only screen and (min-width: ${breakpoints[0]}px) {
    width: 100%;
    max-width: 100%;
    margin-left: 0;
    transform: none;
  }
`

export const PropertiesNearbyHeader = styled.div`
  display: flex;
  align-items: baseline;
  justify-content: space-between;
  gap: 1rem;
  margin-bottom: 1rem;
  padding: 0 ${MOBILE_GUTTER};

  @media only screen and (min-width: ${breakpoints[0]}px) {
    padding: 0;
  }
`

export const PropertiesNearbyHeading = styled.h2`
  font-family: ${({ theme }) => theme.FontHeadingHeading200FontFamily};
  font-size: 20px;
  font-weight: ${({ theme }) => theme.FontHeadingHeading200FontWeight};
  line-height: 28px;
  color: ${({ theme }) => theme.ColorTextBodyOnLight};
  margin: 0;
`

export const ViewMoreButton = styled.button`
  background: none;
  border: none;
  padding: 0;
  cursor: pointer;
  font-size: 14px;
  font-weight: 500;
  white-space: nowrap;
  color: ${({ theme }) => theme.ColorThemeLink};
  text-decoration: underline;

  &:focus-visible {
    outline: 2px solid ${({ theme }) => theme.ColorThemeLink};
    outline-offset: 2px;
  }
`

export const PropertiesNearbyCarouselWrapper = styled.div<{
  $hidePagination?: boolean
}>`
  min-width: 0;
  max-width: 100%;
  /* No padding: the track bleeds to the viewport edges; first/last cards are
     offset via Swiper slidesOffsetBefore/After in PropertiesNearby. */
  padding: 0;

  /* min-width: 0 lets the swiper element shrink to the grid track rather than
     feeding Swiper's set-wrapper-size an unbounded width. */
  swiper-container {
    display: block;
    width: 100%;
    max-width: 100%;
    min-width: 0;
  }

  /* Swiper marks the nav element swiper-button-disabled at the start position. */
  .swiper-prev.swiper-button-disabled {
    visibility: hidden;
  }

  /* The DS fixes .swiper-pagination at 62px (for dynamic bullets) and clips it;
     with static bullets that hides the trailing dots (8 render, ~5 show). Size
     to content instead — && raises specificity so it beats the DS's own rule. */
  && .swiper-pagination {
    width: auto !important;
    max-width: 100%;
  }

  ${({ $hidePagination }) =>
    $hidePagination &&
    `
    && .swiper-pagination {
      display: none;
    }
  `}

  /* The DS IconButton's focus ring is an outset box-shadow the section's
     overflow: hidden clips — redraw it inset so it can't be clipped. */
  .swiper-prev button:focus-visible,
  .swiper-next button:focus-visible,
  .swiper-prev button:active,
  .swiper-next button:active {
    box-shadow: inset 0 0 0 2px ${({ theme }) => theme.ColorThemeLink};
  }

  img {
    max-width: 100%;
    height: auto;
  }
`

export const LowResultsMessageContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  gap: 0.25rem;
  padding: 20px 1rem 0;
`

export const LowResultsHeading = styled.h2`
  font-family: Poppins;
  font-size: 20px;
  font-weight: ${({ theme }) => theme.FontHeadingHeading300FontWeight};
  line-height: 28px;
  color: ${({ theme }) => theme.ColorTextBodyOnLight};
  margin: 0;
`

export const LowResultsSubtext = styled.p`
  font-size: 16px;
  color: ${({ theme }) => theme.ColorTextBodyOnLight};
  margin: 0;
  font-weight: 500;
`

export const LowResultsLink = styled.button`
  background: none;
  border: none;
  padding: 0;
  cursor: pointer;
  font: inherit;
  font-size: 16px;
  color: ${({ theme }) => theme.ColorThemeLink};
  text-decoration: underline;
  font-weight: 500;

  &:focus-visible {
    outline: 2px solid ${({ theme }) => theme.ColorThemeLink};
    outline-offset: 2px;
  }
`
